export enum ZaehlerType {
  KONVENTIONELL = 'KONVENTIONELL',
  SMART_METER = 'SMART_METER',
}
